












import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class FirstCheckBox extends Vue {
  @Prop({ default: '18' })
  public width!: string;

  @Prop({ default: '18' })
  public height!: string;
}
